import LocalizedStrings from 'react-localization';

const strings = new LocalizedStrings({
    en:{
        errorConnexion: 'bad email / password combo',
        title: 'Login',
        emailLabel: 'Email Address',
        emailPlaceholder: 'example@email.com',
        passwordLabel: 'Password',
        passwordLabelConfirmation:'Password confirmation',
        passwordPlaceholder: '••••••••••',
        passwordForgot: "Password forgotten ?",
        registerButton: 'Create an account',
        loginButton: 'Login',

        submitButton: 'Validate',

        generalError: 'An error has occurred, please check your connection',
        rejectionError: 'We could not log you in, please check your email and password',

        forgottenButton: 'I\'ve forgotten my password'
    },
    fr:{
        errorConnexion: "L'association email / mot de passe n'existe pas.",
        title: 'Connexion',
        emailLabel: 'Adresse email',
        emailPlaceholder: 'exaeple@email.fr',
        passwordLabel: 'Mot de passe',
        passwordLabelConfirmation: "Confirmation du mot de passe",
        passwordPlaceholder: '••••••••••',
        passwordForgot: "Mot de passe oublié ? ",
        registerButton: 'Créer une compte',
        loginButton: 'Connexion',

        submitButton: 'Valider',

        generalError: 'Une erreur est servenue, merci de vérifier votre connexion',
        rejectionError: 'Nous ne pouvons vous connecter, merci de vérifier votre addresse mail et votre mot de passe',

        forgottenButton: 'J\'ai oublié mon mot de passe'
    }
})

export default strings